<template>
    <div class="legend-container" >
      <div v-if="!showCustomTable" class="row legend-row" >
        <div class="list-header">
          <div class="row new-width header-row" >
            <div :class="'col-sm-'+ (getCol() + 2) + ' col-xs-' + (getCol() + 2 ) + ' table-heading' ">
                {{ legendTitle }}
            </div>
            <div :class="'col-sm-'+ getCol() + ' col-xs-' + getCol() +  ' table-heading col-area'"
              v-html="tableHeadingTitle"></div>

            <div class="col-sm-2 col-xs-2 table-heading" v-if="showComparativeData">
                Target Area <div>(km<sup>2</sup>)</div>
            </div>

            <div class="col-sm-2 col-xs-2 table-heading" v-if="showComparativeData">
                Area Change <div>(km<sup>2</sup>)</div>
            </div>
            <div class="col-sm-2 col-xs-2 table-heading" v-if="showComparativeData">
                Percent Change <div>(%)</div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 list-body custom-list" >
          <div class="row list-row" v-for="(label, index) in getLabels" :key="index" >
            <div class="col-sm-1 col-xs-1 col-color" >
              <p>
                <span  class="color-holder"
                :id="'color-' + index" @click="selectLayer(label, index)"></span>
              </p>
            </div>
            <div :class="'col-sm-'+ (getCol() + 1) + ' col-xs-' + (getCol() +1) + (showComparativeData ? ' data-label' : '')"
                v-html="label.toLowerCase()">
            </div>
            <div :class="'col-sm-'+ getCol() + ' col-xs-' + getCol() + ' int-col'"
                v-html="getChartDataValue(label)">
            </div>
            <div class="col-sm-2 col-xs-2 int-col" v-if="showComparativeData"
              v-html="parseFloat(comparativeData[label]).toLocaleString()">
            </div>
            <div class="col-sm-2 col-xs-2 int-col" v-if="showComparativeData"
                v-html="parseFloat(transformedComparativeData[label]['difference']).toLocaleString()" >
            </div>
            <div class="col-sm-2 col-xs-2 int-col" v-if="showComparativeData"
                v-html="parseFloat(transformedComparativeData[label]['percentage']).toLocaleString()" >
            </div>
          </div>
        </div>
      </div>

      <div v-else class="row legend-row" >
        <div class="list-header">
          <div class="row new-width header-row" >
            <div class="col-sm-4 col-xs-4 table-heading" v-html="legendTitle">
            </div>
            <div class="col-sm-2 col-xs-2 table-heading col-area" v-html="tableHeadingTitle">
            </div>
            <div class="col-sm-2 col-xs-2 table-heading">
                Target Area <div>(km<sup>2</sup>)</div>
            </div>
            <div class="col-sm-2 col-xs-2 table-heading">
                Area Change <div>(km<sup>2</sup>)</div>
            </div>
            <div class="col-sm-2 col-xs-2 table-heading">
                Percent Change <div>(%)</div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-xs-12 list-body custom-list">
          <div :id="'parent_'+index" class="row list-row" v-for="(label, index) in getLabels" :key="index" >

            <div class="col-sm-1 col-xs-1 col-color" >
              <p :id="'theme-'+index" >
                <span  class="color-holder"
                :id="'color-' + index" @click="selectLayer(label, index)"></span>
              </p>
            </div>
            <div :class="'col-sm-3 col-xs-3' + (showCustomTable ? ' data-label': '')" v-html="label.toLowerCase()">
            </div>
            <div class="col-sm-2 col-xs-2 int-col">
              <input :id="'baseline-'+index" type="text" class="row-edit"
                :value="getChartDataValue(label)" :disabled="!editable"/>
            </div>
            <div class="col-sm-2 col-xs-2 int-col"
              @click="makeEditable($event)">
              <input :id="'target-'+index" type="text" class="row-edit custom" v-on:keyup="completeTable"
                :disabled="!editable"/>
            </div>
            <div class="col-sm-2 col-xs-2 int-col">
              <input :id="'area-'+index" type="text" class="row-edit" :disabled="!editable"/>
            </div>
            <div class="col-sm-2 col-xs-2 int-col">
              <input :id="'percentage-'+index" type="text" class="row-edit" :disabled="!editable"/>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import { bus } from '../../main.js';
    import store from '../../store.js';
    import { mapGetters } from 'vuex';
    import $ from 'jquery';
    export default {
        props: {
            columns: {default: 8},
            colors: {default: () => []},
            legend: {},
            showCustomTable: { default: false },
            showComparativeData: { default: false },
            comparativeData: {default: () => {}},
            chartTitle: { default: () => store.state.indicator.name },
            transformedComparativeData: {default: () => {}},
            units: {default: () => store.state.indicator.unit}
        },
        data () {
            return {
                editable: false,
                titleMap: [ 'Layer Name', 'Baseline Area (sq. km)']
            }
        },
        computed: {
          legendTitle: function() {
            let title;
            if ((this.getDataType === 'xlsx' || this.getDataType === 'xls') && (Object.keys(store.state.xlsData).length==1)){
              title = 'Year';
            }
            else if  (this.getDataType === 'xlsx' || this.getDataType === 'xls'){
              title = 'Sector';
            }
            else if (this.getDataType === 'shp'){
              title = 'Layer Name'
            }
            return title;
          },
          tableHeadingTitle: function () {
              if (this.getDataType === 'xls' || this.getDataType === 'xlsx'){
                 return this.units;
              }else if (this.getDataType === 'shp'){
                return `${this.units}`;
              }
          },
          ...mapGetters([
            'getDataType',
            'getLabels',
            'getChartData',
            'getChartDataWithKey',
            'getSelectedYear'
          ]),
        },
        mounted () {
          for (var x=0; x < this.getLabels.length; x++) {
              let backgroundColor = store.state.colors[x];
              $(`#color-${x}`).css('background-color', backgroundColor);
          }

          // listen for the customize table event on the eventHub (report data selector)
          bus.$on('customize-table', (data) => {
            this.showCustomTable = (data.year > 0)? true : false;
          });
        },
        updated () {
          for (var x=0; x < this.getLabels.length; x++) {
            let backgroundColor = store.state.colors[x];
            $(`#color-${x}`).css('background-color', backgroundColor);
          }
        },
        methods: {
          percentage_change: function(baseline, target) {
            if (isNaN(target)) return 0.0;
            let dataVal;
            if (baseline === 0){
              dataVal = target * 100;
            } else {
              dataVal = ((target * 100) / baseline) - 100;
            }
            let countDecimalResult = this.countDecimals(dataVal);

            if (countDecimalResult !== false && countDecimalResult >= 2 && dataVal < 1) {
              dataVal = Number.parseFloat(dataVal).toExponential(2);
            } else { dataVal = dataVal.toFixed(2) }
            return dataVal;
          },

          area_change: function(baseline, target) {
            if (isNaN(target)) return 0.0;

            let dataVal = target - baseline;
            let countDecimalResult = this.countDecimals(dataVal);

            if (countDecimalResult !== false && countDecimalResult >= 2 && dataVal < 1) {
              dataVal = Number.parseFloat(dataVal).toExponential(2);
            } else { dataVal = dataVal.toFixed(2) }

            return dataVal;
          },

          completeTable: function(event) {
            let child = event.currentTarget.id;
            let child_elem = $(`#${child}`);
            let grand_children = [];

            // variables for targeted table row
            let area_value, percentage_value;
            let baseline_value, target_value;

            //get parent id and element values
            let parent = $(`#${child}`).parent().parent().attr('id');
            let parent_elem = $(`#${parent}`);

            //loop thru the children of the parent to get value
            parent_elem.children().each(function () {
              let grand_child = $(this).children().attr('id');

              if (grand_child !== undefined) {
                let target = grand_child.substr(0, grand_child.indexOf('-'));

                if (target == 'baseline') baseline_value = $(`#${grand_child}`).val();
                if (target == 'target') {
                  target_value = $(`#${grand_child}`).val();
                  if (isNaN(target_value)) target_value = '';
                }

                // add grand child id  to list for fututre reference
                grand_children.push(grand_child);
              }
            });

            area_value = this.area_change(baseline_value, target_value);
            percentage_value = this.percentage_change(baseline_value, target_value);

            //check grand children list and set value to corresponding ids
            if (grand_children.length > 0) {
              grand_children.forEach(function(_child) {
                let elem, temp = _child.substr(0, _child.indexOf('-'));

                if (temp != 'theme' || temp != 'title') {
                  elem = $(`#${_child}`);

                  if (temp == 'area') elem.val(area_value)
                  if (temp == 'baseline') elem.val(baseline_value);
                  if (temp == 'percentage') elem.val(percentage_value);
                  if (temp == 'target') elem.val((target_value !== null? target_value : ''));
                }
              })
            }
          },

          makeEditable: function(event) {
            $(".custom-list").parent().find('input').removeClass("editable", function() {
              $(this).parent().find('input').prop("disabled", true); // element(s) are now disabled.
            });

            let target = event.target;
            if (!$(target).hasClass('editable')) {
              $(target).prop("disabled", false); // target element now enabled.
              $(target).addClass('editable');
              $(target).focus()
            }
          },

          getCol: function(){
              let col = 5
              if(this.showComparativeData){
                  col = 2;
              }
              return col;
          },

          selectLayer: function (label, index) {
            if (this.getDataType === 'shp') {
              let layer =  store.state.geoJsonLayers.filter(
                  object => Object.keys(object)[0] === label
              )[0];
              let key = Object.keys(layer)[0];
              let _layer = layer[key];
              let color = '';

              for ( var x = 0; x < this.getLabels.length; x++) {
                if (this.getLabels[x] === key){
                  color = store.state.colors[x];
                  break;
                }
              }

              let isChecked = $(`#color-${index}`).hasClass('fa fa-check');

              if (!isChecked) {
                _layer.color = color;
                _layer.key = key;
                $(`#color-${index}`).addClass('fa fa-check');
                store.dispatch('setActiveLayer', _layer);
              } else {
                store.dispatch('removeLayer', _layer)
                $(`#color-${index}`).removeClass('fa fa-check');
              }
            }
          },

          // getChartDataValue: function(key){
          //   if (this.getDataType === 'shp') {
          //     let foundItem = this.getChartDataWithKey.find((data) => {
          //       return data.key === key
          //     });
          //     return foundItem ? foundItem.value : 0.00;
          //   }else if (this.getDataType === 'xls' || this.getDataType === 'xlsx'){
          //     let chartData = store.state.xlsData[this.getSelectedYear].data;
          //     //console.log('CHART DATA', chartData, key);
          //     return chartData[key];
          //   }
          // },

          countDecimals: function (value) {
            if(Math.floor(value) === value) return false;
              var decimal=value.toString().split(".")[1];
              if (decimal){
                return decimal.length || 0;
              }
          },

          getChartDataValue: function(key){
            let dataVal;
            if (this.getDataType === 'shp') {
              let foundItem = this.getChartDataWithKey.find((data) => {
                return data.key === key
              });
              dataVal = foundItem ? foundItem.value : 0.00;
            }else if ((this.getDataType === 'xls' || this.getDataType === 'xlsx')){
              let chartData = store.state.xlsData[this.getSelectedYear].data;
              dataVal = chartData[key];
              dataVal = Math.round(dataVal*100)/100;
            }
            let countDecimalResult = this.countDecimals(dataVal)
            if (countDecimalResult !== false && countDecimalResult >= 2 && dataVal < 1) {
              dataVal = Number.parseFloat(dataVal).toExponential(2);
            }
            return dataVal;
          }
        }
    }
</script>

<style scoped lang="scss">
  @import "../../css/constants";

    .property { margin-top: 10px; line-height: 20px; }

    .legend-row {
      height: 100%;
      margin-right: 0px;
      margin-left: 0px;

      .list-body {
        height: calc(100% - 110px);
        padding-right: 0px;
        padding-left: 0px;
        margin: 0;
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar { width: 8px; }
        &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
          border-radius: 30px;
        }

        &::-webkit-scrollbar-thumb {
          cursor: pointer;
          background: -webkit-linear-gradient(to right, #35B8FB, #56CCF2);
          background: linear-gradient(to right, #35B8FB, #56CCF2);
          outline: 1px solid slategrey;

          border-radius: 30px;
          -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
          &:hover { background: #35B8FB; }
        }

        p { line-height: 20px; font-size: 0.813em; }

        .list-row {
          padding: 8px 6px;
          border-bottom: 1px solid #f0f4f7;
          height: auto;
          min-height: 11%;
          overflow: hidden;

          font-size: 0.80em !important;
          font-weight: normal !important;
          color: $gray7 !important;

          .int-col{
            height: auto!important;
            text-align: right;

            input {
              width: 80px;
              text-align: center;
              font-weight: normal !important;
              margin-left: 12px;
              padding: 0px !important
            }

            input.custom {
              height: 30px;
              cursor: pointer;
              color: #000;

              text-align: center;
              margin-top: -7px;
              margin-left: 20px;
              padding: 3px 4px;
              background: $gray2;
            }
          }

          margin-right: 0px;
          margin-left: 0px;
          text-align: center;

          input.row-edit { border: none; }
          input.editable { background: #56CCF2 !important; }
        }

        .col-color { padding: 0px; }
      }
    }

    .color-holder {
      height:20px;
      width:20px;
      float: left;
      border-radius: 7px;
      display: inline-block;
      vertical-align: baseline;
      padding-top: 5px;
      text-align: center;
      color:white;
    }

    input[type="checkbox"]{ margin-top: 10px; }
    p { line-height: 50px; }

    .col-sm-1 {
        width: 6.333333%;
        height: auto;
        margin: 6px 0;
    }

    .col-sm-2 {
      height: auto;
      margin: 7px 0;
      p { padding: 0; }
    }

    .list-body > .list-row > .data-label{
      max-width: 24%;
      overflow-wrap:break-word;
      word-wrap: break-word;
      -webkit-hyphens: auto;
      -moz-hyphens: auto;
      -ms-hyphens: auto;
      hyphens:auto

    }

    .list-header {
        padding-bottom:12px;
        border-bottom: 1px solid #416b82;
        color: #416b82;
        margin-bottom: 10px;
        text-align: center;

        .header-row {
          margin-right: 0px;
          margin-left: 0px;
          color: #5386a0;
          padding-top: 10px;
          padding-bottom: 10px;

          .col-sm-5.col-area {
            text-align: right;
          }
        }

        .col-sm-2 {
          padding-left: 10px;
          padding-right: 10px;
        }

        .table-heading:first-child {
          text-align: left;
        }

        .table-heading {
          font-size: 0.875em;
          font-weight: 900;
        }
    }

.fa {
    font-size: 11px;
}
.legend-container{
    height:100%;
}

.col-sm-3, .col-xs-3 { height: auto; min-height: 70px; }
sup { font-size: 0.8em !important; font-weight: bold; }

@media only screen and (min-width: 1024px) {
  /* For mobile phones: */
  .legend-row {
    height: 100%;
    .list-body {
      height: calc(100% - -60px);
    }

  }
}

@media only screen and (min-width: 768px) {
  /* For mobile phones: */
  .list-body {
    height: calc(100vh - 10px);
    overflow-y: hidden;
    overflow-x: hidden;
  }
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  /* For mobile phones: */
}

@media only screen and (max-width: 468px) {
  /* For mobile phones: */
}

</style>



// WEBPACK FOOTER //
// src/components/report/ReportLegend.vue